module.exports = __webpack_public_path__ + "static/media/iconStudentsGirls.e04615b9.svg";